export type GenderMessages = {
  maleOption: string;
  femaleOption: string;
  unspecifiedOption: string;
  noneOption: string;
};

export const GENDER_MESSAGES: GenderMessages = {
  maleOption: "Masculino",
  femaleOption: "Feminino",
  unspecifiedOption: "Não informado",
  noneOption: "Nenhum",
};
